import React from 'react';
import { Route, Switch } from 'react-router-dom';

///USUÁRIO///
import ListarUsuarios from './components/Usuario/Listar-Usuarios';
import CadastrarUsuario from './components/Usuario/Cadastrar-Usuario';

///PRESTADOR///
import ListarPrestador from './components/Prestador/Listar-Prestador';
import ListarPrestadorTipoAgendamento from './components/Servicos/Listar-Prestador-Tipo-Agendamento';
import CadastrarPrestador from './components/Prestador/Cadastrar-Prestador';
import CadastrarPrestadorTipoAgendamento from './components/Servicos/Cadastrar-Prestador-Tipo-Agendamento';

///AGENDA///
import ListarAgenda from './components/Agenda/Listar-Agenda';
import CadastrarAgenda from './components/Agenda/Cadastrar-Agenda';

///AGENDAMENTO///
import ListarTipoAgendamento from './components/Servicos/Listar-Tipo-Agendamento';
import CadastrarTipoAgendamento from './components/Servicos/Cadastrar-Tipo-Agendamento';
import CalendarioAgendamento from './components/Agendamento/Calendario-Agendamento';

///EMPRESA///
import ListarEmpresa from './components/Empresa/Listar-Empresa';
import ListarCategoriaEmpresa from './components/Empresa/Listar-Categoria-Empresa';
import CadastrarEmpresa from './components/Empresa/Cadastrar-Empresa';
import CadastrarCategoriaEmpresa from './components/Empresa/Cadastrar-Categoria-Empresa';

///FINANCEIRO///
import ListarPagamento from './components/Financeiro/Listar-Pagamentos';
import VisualizarPagamento from './components/Financeiro/Visualizar-Pagamento';
import ListarTaxasPorEmpresa from './components/Financeiro/Listar-Taxas-Por-Empresa';

///CONFIG///
import ListarConfigs from './components/Configs/Listar-Configs';
import CadastrarConfigs from './components/Configs/Cadastrar-Configs';
import ListarRoles from './components/Configs/Listar-Perfis-Acesso'
import CadastrarRole from './components/Configs/Cadastrar-Perfil-Acesso'

import Dashboard from './components/Dashboard';

import PerfilUsuario from './components/Usuario/Perfil-Usuario';


const AppRouter = () => {
    return (
        <Switch>
            <Route path="/" exact component={Dashboard} />
            <Route path="/usuarios/listar" component={ListarUsuarios} />
            <Route path="/usuarios/cadastrar" component={CadastrarUsuario} />
            <Route path="/usuarios/visualizar/:id" component={CadastrarUsuario} />

            <Route path="/prestador/listar" component={ListarPrestador} />
            <Route path="/prestador/cadastrar" component={CadastrarPrestador} />
            <Route path="/prestador/editar/:id" component={CadastrarPrestador} />

            <Route path="/prestador/tipo/agendamento/listar" component={ListarPrestadorTipoAgendamento} />
            <Route path="/prestador/tipo/agendamento/cadastrar" component={CadastrarPrestadorTipoAgendamento} />
            <Route path="/prestador/tipo/agendamento/editar/:id" component={CadastrarPrestadorTipoAgendamento} />

            <Route path="/agendamento/listar" component={CalendarioAgendamento} />
            {/* lista os agendamentos do prestador logado */}
            <Route path="/agendamento/prestador/:id" component={CalendarioAgendamento} />
            <Route path="/agendamento/tipo/listar" component={ListarTipoAgendamento} />
            <Route path="/agendamento/tipo/cadastrar" component={CadastrarTipoAgendamento} />
            <Route path="/agendamento/tipo/editar/:id" component={CadastrarTipoAgendamento} />

            <Route path="/agenda/listar" component={ListarAgenda} />
            {/* lista a agenda do prestador logado */}
            <Route path="/agenda/prestador/listar/:id" component={ListarAgenda} />
            <Route path="/agenda/cadastrar" component={CadastrarAgenda} />
            <Route path="/agenda/editar/:id" component={CadastrarAgenda} />

            <Route path="/empresa/listar" component={ListarEmpresa} />
            <Route path="/empresa/cadastrar" component={CadastrarEmpresa} />
            <Route path="/empresa/editar/:id" component={CadastrarEmpresa} />

            <Route path="/empresa/categoria/listar" component={ListarCategoriaEmpresa} />
            <Route path="/empresa/categoria/cadastrar" component={CadastrarCategoriaEmpresa} />
            <Route path="/empresa/categoria/editar/:id" component={CadastrarCategoriaEmpresa} />

            <Route path="/pagamento/listar" component={ListarPagamento} />
            <Route path="/pagamento/prestador/listar/:id" component={ListarPagamento} />
            <Route path="/pagamento/visualizar/:id" component={VisualizarPagamento} />

            <Route path="/taxas_por_empresa/listar" component={ListarTaxasPorEmpresa} />

            <Route path="/configs/listar" component={ListarConfigs} />
            <Route path="/configs/cadastrar" component={CadastrarConfigs} />
            <Route path="/configs/editar/:id" component={CadastrarConfigs} />

            <Route path="/roles/listar" component={ListarRoles} />
            <Route path="/roles/cadastrar" component={CadastrarRole} />
            <Route path="/roles/editar/:id" component={CadastrarRole} />
            {/* <Route path="/cadastro/lojas/cadastrar" component={CadastrarLoja} /> */}

            <Route path="/profile" component={PerfilUsuario} />
        </Switch>
    );
};

export default AppRouter;